import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { BrowserWorkbenchEnvironmentService } from './vscode/src/vs/workbench/services/environment/browser/environmentService.js';
import { IEnvironmentService } from 'vscode/vscode/vs/platform/environment/common/environment.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { logsPath, getWorkspaceIdentifier, getWorkbenchConstructionOptions } from 'vscode/workbench';

let InjectedBrowserWorkbenchEnvironmentService = class InjectedBrowserWorkbenchEnvironmentService extends BrowserWorkbenchEnvironmentService {
    constructor(workspaceId = getWorkspaceIdentifier().id, options = getWorkbenchConstructionOptions(), productService) {
        super(workspaceId, logsPath, options, productService);
    }
};
InjectedBrowserWorkbenchEnvironmentService = __decorate([
    ( __param(2, IProductService))
], InjectedBrowserWorkbenchEnvironmentService);
function getServiceOverride(options) {
    return {
        [( IEnvironmentService.toString())]: new SyncDescriptor(InjectedBrowserWorkbenchEnvironmentService, [undefined, options], true)
    };
}

export { getServiceOverride as default };
